<template>
  <a-textarea
      v-show="info.status === 'edit'"
      v-model:value="data[propName]"
      :placeholder="'请填写' + info.title"
      :allowClear="true"
      :showCount="true"
      :auto-size="{ minRows: 4, maxRows: 8 }"
  />
  <div v-show="info.status === 'show'" class="view">
    {{ data[propName] }}
  </div>
</template>
<script lang="ts">

import {definedWidgetMeta} from "@/components/business/crud/widgets/widgetManager";

export const meta = definedWidgetMeta({
  size: {edit: "large", show: "large"}
});
</script>

<script lang="ts" setup>
import {defineProps} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import TextareaTable from "./TextareaTable.vue";
import {TextAreaFieldType} from "@/components/business/crud/interface/FieldType";

const props = defineProps<{
  propName: string;
  widget: TextAreaFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();


</script>


<style lang="scss" scoped>
.view {
  height: 100%;
  padding-left: 12px;
  white-space: pre-line;
}
</style>
